export default __webpack_public_path__ + "static/media/halonasoft-logotype-d.4d5d94ed.svg";